import React from 'react';
import styles from './BodyFilter.module.scss';
import { SavedFilter } from '../../saved';
import {
  AddressFilterCard,
  CriteriaFilterCard,
  PeriodSelectionFilterCard,
  RelatedPersonsFilterCard,
} from '../../cards';

const BodyFilter = () => {
  return (
    <div className={styles.root}>
      <SavedFilter />
      <div className={styles.contentForm}>
        <PeriodSelectionFilterCard />
        <CriteriaFilterCard />
        <RelatedPersonsFilterCard />
        <AddressFilterCard />
      </div>
    </div>
  );
};

export default BodyFilter;
